/**
 * AIDEV-NOTE [MEETBALL magic-link]: this module exists for ONE reason: to make the
 * capture-and-strip an IMPORT rather than a statement.
 *
 * ES module imports are evaluated, in source order, before ANY statement in the
 * importing module's body runs. `src/index.tsx` imports `./router`, and
 * `src/router.tsx` calls `createBrowserRouter([...])` at module scope, which
 * snapshots `window.location` there and then. A `captureAuthLinkParams()` call
 * sitting in index.tsx's body therefore always ran AFTER the router had already
 * read the URL, token and all. `history.replaceState` fires no popstate, so
 * react-router keeps serving that stale snapshot from `useLocation()` and
 * `useSearchParams()` for the life of the document: `AnalyticsBootstrapper`
 * composes `landing_path` from it, and AuthDoor's mount effect reads a query
 * string that the address bar no longer shows.
 *
 * Importing this module FIRST in src/index.tsx is what fixes that, because it is
 * the only construct that is guaranteed to run before the router module body.
 * Keep it a bare side-effect import at the top of index.tsx. It exports nothing
 * on purpose: an export would invite someone to reorder the import next to its
 * siblings, and the order is the whole point.
 */
import { captureAuthLinkParams } from './authLinkParams';

captureAuthLinkParams();
